import { useMemo, useState } from "preact/hooks";

const unixMsToLocalISOString = (time: number, useSecond: boolean = true) => {
    const localTime = new Date(time);
    const offsetMs = localTime.getTimezoneOffset() * 60 * 1000;
    const fakeTime = new Date(time - offsetMs);
    const localISOString = fakeTime.toISOString().substring(0, useSecond ? 19 : 16);
    return localISOString;
};

const setDatetimeInputValue = (setValue: (v: number) => unknown, evt: Event) => {
    const elem = evt.target as HTMLInputElement;
    const timestamp = Date.parse(elem.value); // time zone offset applied by the Date class
    if (!Number.isNaN(timestamp)) {
        setValue(timestamp);
    }
};

export const useLocalTimeISOString = (initUnixTime: number, useSecond: boolean = true) => {
    const [utime, setTime] = useState(initUnixTime);

    const setLocalTimeISOString = useMemo(() => {
        return setDatetimeInputValue.bind(null, setTime);
    }, [setTime]);

    const localTimeISOString = useMemo(() => {
        return unixMsToLocalISOString(utime, useSecond);
    }, [utime, useSecond]);

    return {
        localTimeISOString,
        datetimeLocalOnChange: setLocalTimeISOString,
        unixTimestampMs: utime,
    };
};
export default useLocalTimeISOString;
